import { RequestState, RequestStateAction } from "./types";
import { RequestActionType } from "./constants";

export const reducer = <T>(
  state: RequestState<T>,
  { type, payload, meta }: RequestStateAction<T>,
): RequestState<T> => {
  switch (type) {
    case RequestActionType.InProgress:
      return {
        isLoading: true,
        data: meta?.shouldResetData ? undefined : state.data,
        error: meta?.shouldResetError ? undefined : state.error,
      };

    case RequestActionType.Success: {
      return {
        isLoading: false,
        data: payload?.data,
        error: meta?.shouldResetError ? undefined : state.error,
      };
    }

    case RequestActionType.Error:
      return {
        isLoading: false,
        data: meta?.shouldResetData ? undefined : state.data,
        error: payload?.error,
      };

    case RequestActionType.Reset:
      return {
        isLoading: Boolean(payload?.isLoading),
        data: payload?.data,
        error: payload?.error,
      };

    default:
      return state;
  }
};
